'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = combineActions;

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _isFunction = require('./utils/isFunction');

var _isFunction2 = _interopRequireDefault(_isFunction);

var _isSymbol = require('./utils/isSymbol');

var _isSymbol2 = _interopRequireDefault(_isSymbol);

var _isEmpty = require('./utils/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _toString = require('./utils/toString');

var _toString2 = _interopRequireDefault(_toString);

var _isString = require('./utils/isString');

var _isString2 = _interopRequireDefault(_isString);

var _constants = require('./constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isValidActionType(type) {
  return (0, _isString2.default)(type) || (0, _isFunction2.default)(type) || (0, _isSymbol2.default)(type);
}

function isValidActionTypes(types) {
  if ((0, _isEmpty2.default)(types)) {
    return false;
  }
  return types.every(isValidActionType);
}

function combineActions() {
  for (var _len = arguments.length, actionsTypes = Array(_len), _key = 0; _key < _len; _key++) {
    actionsTypes[_key] = arguments[_key];
  }

  (0, _invariant2.default)(isValidActionTypes(actionsTypes), 'Expected action types to be strings, symbols, or action creators');
  var combinedActionType = actionsTypes.map(_toString2.default).join(_constants.ACTION_TYPE_DELIMITER);
  return { toString: function toString() {
      return combinedActionType;
    } };
}


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/lib/combineActions.js
// module id = 2440
// module chunks = 0